import React, { useEffect, useState } from "react";
import { RCCBadge, RCCIcon, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import BadgeTraceabilityCard from "src/pages/Actions/Panel/components/BadgeTraceability/badgeTraceabilityCard";
import IComponentBadge from "react-common-components/dist/components/Badge/interface";
import { useAuth } from "src/context/Auth/context";
import { checkSituationOccurrence, IOccurrence, IRefModalRegisterHistory } from "../../interface";
import { DivFlex, DivIcons } from "../ListOccurrences/styles";

export interface IComponentBadgeSituationOcurrences{
    ocurrence: any;
    refModalRegisterHistory?: React.RefObject<IRefModalRegisterHistory>;
    openModalAttachments?: (row: IOccurrence) => void;
    openModalHistory?: (row: IOccurrence) => void;
    openModalImmediateActions?: (row: IOccurrence) => void;
}

const BadgeSituationOcurrences: React.FC<IComponentBadgeSituationOcurrences> = ({
	ocurrence,
	refModalRegisterHistory,
	openModalAttachments,
	openModalHistory,
	openModalImmediateActions
}) => {
	const { translate } = useTranslation();
	const { administrator, superUser, user } = useAuth();
	const [color, setColor] = useState<IComponentBadge["color"]>();
	const [text, setText] = useState<string>();

	const getSituation = (row: any) => {

		if(row.late && (row.ocb001Status === checkSituationOccurrence.OPENED || row.ocb001Status === checkSituationOccurrence.NOT_STARTED)){
			setText(translate("Atrasada"));
			setColor("red");
		}else{
			switch(row.ocb001Status){
			case checkSituationOccurrence.NOT_STARTED:
				setText(translate("Não iniciada"));
				setColor("blue");
				break;
			case checkSituationOccurrence.OPENED:
				setText(translate("Em andamento"));
				setColor("purple");
				break;
			case checkSituationOccurrence.FINISHED:
				setText(translate("Finalizada"));
				setColor("green");
				break;
			case checkSituationOccurrence.CANCELED:
				setText(translate("Cancelada"));
				setColor("grey");
				break;
			case checkSituationOccurrence.DISAPPROVED:
				setText(translate("Reprovada"));
				setColor("black");
				break;
			default: 
				setText("");
				setColor("green");
				break;
			}
		}
	};

	useEffect(() => {
		getSituation(ocurrence);
	},[]);

	const statusLateOrOpendOrNotstarted = ocurrence.ocb001Status === checkSituationOccurrence.LATE || ocurrence.ocb001Status === checkSituationOccurrence.OPENED || ocurrence.ocb001Status === checkSituationOccurrence.NOT_STARTED;
	const canRecordHistory = administrator || superUser || ocurrence.ocb001Efa005Id2 === user.efa005Id;

	return(
		<>
			<>
				{refModalRegisterHistory && statusLateOrOpendOrNotstarted && canRecordHistory ? (
					<RCCBadge 
						color={color} 
						styleInline="padding: 2px 8px; font-size: 0.78rem; cursor: pointer;"
						onClick={() => {
							refModalRegisterHistory?.current?.actionButtonRegisterHistory(ocurrence);
						}}
					>
						{text}
					</RCCBadge>
				): (
					<RCCBadge color={color} styleInline="padding: 2px 8px; font-size: 0.78rem;">{text}</RCCBadge>
				)
				}
				{ocurrence.ocb001Reincidente === "S" && (
					<BadgeTraceabilityCard 
						id={ocurrence.ocb001Id}
						controllerMethod="Occurrences"
						textBadge={translate("Reincidente")}
						color="red"
					/>
				)}
			</>
			<DivFlex>
				<DivIcons 
					onClick={() => {
						if(openModalHistory)
							openModalHistory(ocurrence);
					}}
				>
					<RCCTooltip 
						text={translate("Histórico")}
					>
						<RCCIcon name="history" color="var(--default-color-font)" size={12}/>
					</RCCTooltip>
				</DivIcons>
				<DivIcons 
					onClick={() => {
						if(openModalAttachments)
							openModalAttachments(ocurrence);
					}}
				>
					<RCCTooltip 
						text={translate("Anexos")}
					>
						<RCCIcon name="attachment" color="var(--default-color-font)" size={12}/>
						{ocurrence.attachmentsNumber > 0 && ocurrence.attachmentsNumber}
					</RCCTooltip>
				</DivIcons>
				<DivIcons 
					onClick={() => {
						if(openModalImmediateActions)
							openModalImmediateActions(ocurrence);
					}}
				>
					<RCCTooltip 
						text={translate("Ações Imediatas")}	
					>
						<RCCIcon name="bars" color="var(--default-color-font)" size={12}/>
						{ocurrence.immediateActionsNumber > 0 && ocurrence.immediateActionsNumber}
					</RCCTooltip>
				</DivIcons>
			</DivFlex>  
		</>
	);
};

export default BadgeSituationOcurrences;
